import { Typography, Button } from "../../components"
import "./styles.css";

import routekaartlactatiekundigen from '../../assets/documents/library/routekaartlactatiekundigen2026.pdf';

export default function RoutekaartLactatiekundigen(props) {
    return (
        <div className='container'>
            <Typography type='h1' style={{ color: 'var(--trust)', fontSize: '2.2em' }}>Routekaart voor Lactatiekundigen</Typography>
            <div className="button-container">
                <Button 
                    target='_blank' 
                    href={routekaartlactatiekundigen} 
                    text={`Klik hier voor onze Routekaart voor lactatiekundigen`}
                />  
            </div>
        </div>
    )
}